// extracted by mini-css-extract-plugin
export default {"cart":"CartUI_cart__ikKmM"};